// @flow
import { PRODUCT_IMAGE_MAP } from 'Client/cms/toolkit/constants';
import { ProductImageMapLine } from 'Components/lines/product-image-map-line/ProductImageMapLine.jsx';
import { productImageMapResolver } from './productImageMap.resolver';

export const productImageMapDescriptor = {
  name: PRODUCT_IMAGE_MAP,
  component: ProductImageMapLine,
  resolve: productImageMapResolver.resolve,
};
